export default {
    didNumber: {
        data: [],

    },
};